import React, { useContext } from "react"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"

export const AccessTokenForm = ({ accessToken, setAccessToken }) => {
	const { state, dispatch } = useContext(GlobalStateContext)

	const changeAccessToken = (e) => {
		setAccessToken(e.target.value)
	}

	return (
		<>
			<div style={{ width: "20rem" }}>
				<div
					style={{
						fontSize: "0.9rem",
						fontWeight: "600",
						color: "#222",
					}}
				>
					Access Token
				</div>
				<div style={{ position: "relative", marginTop: "0.2rem" }}>
					<svg
						style={{
							position: "absolute",
							top: "0.5rem",
							left: "0.5rem",
							height: "1.2rem",
							width: "1.2rem",
						}}
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M7 14q-.825 0-1.413-.588T5 12q0-.825.588-1.413T7 10q.825 0 1.413.588T9 12q0 .825-.588 1.413T7 14Zm0 4q-2.5 0-4.25-1.75T1 12q0-2.5 1.75-4.25T7 6q1.675 0 3.038.825T12.2 9H21l3 3l-4.5 4.5l-2-1.5l-2 1.5l-2.125-1.5H12.2q-.8 1.35-2.163 2.175T7 18Zm0-2q1.4 0 2.463-.85T10.875 13H14l1.45 1.025L17.5 12.5l1.775 1.375L21.15 12l-1-1h-9.275q-.35-1.3-1.413-2.15T7 8Q5.35 8 4.175 9.175T3 12q0 1.65 1.175 2.825T7 16Z"
						></path>
					</svg>
					<input
						name="Access Token"
						placeholder="shpat_abc123def456ghi789"
						onChange={changeAccessToken}
						value={accessToken}
						className="border shadow"
						style={{
							borderRadius: "1rem",
							padding: "0.5rem",
							paddingLeft: "2rem",
							fontSize: "0.9rem",
							width: "100%",
						}}
					/>
				</div>
			</div>
		</>
	)
}
